

import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ConnfirmDeleteAppoinnmentModal({
  open,
  handleClose,
  handleConfirm,
}) {

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Вы точно хотите отменить прием?"}
      </DialogTitle>
      {/* <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent> */}
      <DialogActions>
        <Button onClick={handleClose}>Нет</Button>
        <Button
          onClick={handleConfirm}
          autoFocus
          variant="contained"
          color="primary"
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
}
